import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const advSwitch = {
  createBannerPosition: lazyModuleMethod(
    () => import('./createBannerPosition'),
    'default'
  ),
  deleteBannerPosition: lazyModuleMethod(
    () => import('./deleteBannerPosition'),
    'default'
  ),
  fetchAdSiteSection: lazyModuleMethod(
    () => import('./fetchAdSiteSection'),
    'default'
  ),
  fetchAdBannerPosition: lazyModuleMethod(
    () => import('./fetchAdBannerPosition'),
    'default'
  ),
  createAdSiteSection: lazyModuleMethod(
    () => import('./createAdSiteSection'),
    'default'
  ),
  deleteAdSiteSection: lazyModuleMethod(
    () => import('./deleteAdSiteSection'),
    'default'
  ),
  updateAdSiteSection: lazyModuleMethod(
    () => import('./updateAdSiteSection'),
    'default'
  ),
  updateBannerPosition: lazyModuleMethod(
    () => import('./updateBannerPosition'),
    'default'
  ),
}
